import { render, staticRenderFns } from "./PlpTaskUpdLog.vue?vue&type=template&id=b637b082"
import script from "./PlpTaskUpdLog.vue?vue&type=script&lang=js"
export * from "./PlpTaskUpdLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports